"use client";

import { motion } from "framer-motion";
import { Calendar, Ruler, Package } from "lucide-react";
import { HOW_IT_WORKS } from "@/lib/marketing/copy";
import { howItWorksImages } from "@/lib/marketing/images";
import { SectionHeader } from "@/components/common/SectionHeader";

const iconMap = {
  Calendar,
  Ruler,
  Package,
};

export function HowItWorks() {
  return (
    <section id="how-it-works" className="zaklyn-section">
      <div className="zaklyn-container">
        <SectionHeader
          title={HOW_IT_WORKS.title}
          subtitle={HOW_IT_WORKS.subtitle}
        />

        <div className="grid md:grid-cols-3 gap-8 md:gap-12">
          {HOW_IT_WORKS.steps.map((step, index) => {
            const Icon = iconMap[step.icon as keyof typeof iconMap];
            const image = howItWorksImages[index];

            return (
              <motion.div
                key={step.number}
                initial={{ opacity: 0, y: 30 }}
                whileInView={{ opacity: 1, y: 0 }}
                viewport={{ once: true, margin: "-50px" }}
                transition={{ duration: 0.6, delay: index * 0.1 }}
                className="relative"
              >
                <div className="relative aspect-[4/3] rounded-2xl overflow-hidden mb-6">
                  <img
                    src={image.src}
                    alt={image.alt}
                    className="w-full h-full object-cover"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-foreground/40 to-transparent" />
                  <div className="absolute bottom-4 left-4 w-12 h-12 flex items-center justify-center bg-white rounded-xl shadow-zaklyn">
                    <Icon className="h-6 w-6 text-primary" />
                  </div>
                </div>

                <div className="relative">
                  <span className="font-display text-6xl font-bold text-primary/10 absolute -top-8 -left-2">
                    {step.number}
                  </span>
                  <h3 className="font-display text-xl md:text-2xl font-semibold text-foreground relative z-10">
                    {step.title}
                  </h3>
                  <p className="mt-3 text-muted-foreground font-body leading-relaxed">
                    {step.description}
                  </p>
                </div>

                {index < HOW_IT_WORKS.steps.length - 1 && (
                  <div className="hidden md:block absolute top-1/4 -right-6 w-12 h-0.5 bg-border" />
                )}
              </motion.div>
            );
          })}
        </div>
      </div>
    </section>
  );
}
